import { useState, useCallback } from 'react';

const useTemporaryMessage = (duration = 3000) => {
    const [message, setMessage] = useState(null);

    const showMessage = useCallback((newMessage) => {
        setMessage(newMessage);
        setTimeout(() => setMessage(null), duration);
    }, [duration]);

    return [message, showMessage];
};

export default useTemporaryMessage; 